import React from 'react';
import type { PriorAuthorizationClaimContext } from '@features/patient-coverages/types';
import FactCheckOutlined from '@mui/icons-material/FactCheckOutlined';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import { Chip, Tooltip } from '@mui/material';

export interface PriorAuthorizationIndicatorProps {
  context: PriorAuthorizationClaimContext;
  isHovered?: boolean;
  onClick?: () => void;
}

export const PriorAuthorizationIndicator: React.FC<PriorAuthorizationIndicatorProps> = ({
  context,
  isHovered = false,
  onClick,
}) => {
  const attention = context.indicator_state === 'attention';
  const label = context.indicator_label ?? 'Authorization needs review';
  return (
    <Tooltip arrow placement="bottom" title={label}>
      <Chip
        icon={attention ? <WarningAmberOutlined /> : <FactCheckOutlined />}
        label={label}
        color={attention ? 'warning' : 'primary'}
        variant={isHovered ? 'filled' : 'outlined'}
        onClick={onClick}
        aria-label={label}
        sx={{
          height: 32,
          fontWeight: 700,
          bgcolor: isHovered ? undefined : 'background.paper',
          '& .MuiChip-icon': { fontSize: 17 },
        }}
      />
    </Tooltip>
  );
};
